/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum indicating the quadrant of the city where a Site (rental location) is located.
 */
export enum HousingSiteQuadrant {
    NORTHWEST = 'Northwest',
    NORTHEAST = 'Northeast',
    SOUTHWEST = 'Southwest',
    SOUTHEAST = 'Southeast',
    CENTRAL = 'Central',
}
